import React, { useState } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="border-t border-white/5 bg-navy-900" data-id="element-149">
        <div className="max-w-3xl mx-auto px-6 py-10" data-id="element-150">
          {/* Top row */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8" data-id="element-151">
            <p className="font-playfair text-lg font-bold text-offwhite/80" data-id="element-152">
              El Filtro Magnético
            </p>
            <div className="flex items-center gap-2 text-offwhite/40 text-xs" data-id="element-153">
              <ShieldCheckIcon className="w-4 h-4 text-green-400/70" data-id="element-154" />
              <span data-id="element-155">Pagos seguros y encriptados</span>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-white/5 mb-8" data-id="element-156" />

          {/* Bottom row */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-offwhite/40" data-id="element-157">
            <p data-id="element-158">
              © {new Date().getFullYear()} El Filtro Magnético. Todos los
              derechos reservados.
            </p>
            <div className="flex items-center gap-6" data-id="element-159">
              <button onClick={() => setShowPrivacy(true)} className="hover:text-gold transition-colors underline-offset-2 hover:underline" data-id="element-160">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="hover:text-gold transition-colors underline-offset-2 hover:underline" data-id="element-161">
                Términos y Condiciones
              </button>
            </div>
          </div>

          {/* Facebook disclaimer */}
          <p className="text-center text-[10px] text-offwhite/25 mt-6 leading-relaxed" data-id="element-162">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. Facebook es una marca registrada de Facebook, Inc.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-163">
        <p className="text-offwhite/50 text-xs" data-id="element-164">
          Última actualización: abril 2026
        </p>

        <h3 className="text-offwhite font-bold text-base mt-2" data-id="element-165">
          1. Información que recopilamos
        </h3>
        <p data-id="element-166">
          Al realizar una compra, recopilamos tu nombre y dirección de correo
          electrónico con el único propósito de entregar el producto digital
          adquirido y enviarte comunicaciones relacionadas con tu compra.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-167">
          2. Uso de la información
        </h3>
        <p data-id="element-168">
          Tu información personal se utiliza exclusivamente para: (a) procesar y
          entregar tu pedido, (b) enviarte actualizaciones relacionadas con el
          producto, y (c) brindarte soporte si lo solicitas. No vendemos,
          alquilamos ni compartimos tu información con terceros.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-169">
          3. Protección de datos
        </h3>
        <p data-id="element-170">
          Implementamos medidas de seguridad estándar de la industria para
          proteger tu información personal. Los pagos son procesados por
          plataformas de pago seguras y encriptadas; no almacenamos datos de
          tarjetas de crédito en nuestros servidores.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-171">4. Cookies</h3>
        <p data-id="element-172">
          Este sitio puede utilizar cookies para mejorar la experiencia del
          usuario y con fines analíticos. Puedes configurar tu navegador para
          rechazar cookies, aunque esto podría afectar la funcionalidad del
          sitio.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-173">5. Tus derechos</h3>
        <p data-id="element-174">
          Puedes solicitar la eliminación de tus datos personales en cualquier
          momento contactándonos directamente. Atenderemos tu solicitud en un
          plazo máximo de 30 días.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-175">
          6. Cambios a esta política
        </h3>
        <p data-id="element-176">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios serán publicados en esta misma página con la
          fecha de actualización correspondiente.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-177">
        <p className="text-offwhite/50 text-xs" data-id="element-178">
          Última actualización: abril 2026
        </p>

        <h3 className="text-offwhite font-bold text-base mt-2" data-id="element-179">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-180">
          Al acceder a este sitio web y/o adquirir el producto "El Filtro
          Magnético", aceptas estos términos y condiciones en su totalidad. Si
          no estás de acuerdo, no utilices este sitio ni adquieras el producto.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-181">
          2. Producto digital
        </h3>
        <p data-id="element-182">
          "El Filtro Magnético" es un producto digital de información y
          educación. El acceso se entrega de forma inmediata a la dirección de
          correo electrónico proporcionada al momento de la compra. El acceso es
          de por vida desde la fecha de compra.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-183">
          3. Propiedad intelectual
        </h3>
        <p data-id="element-184">
          Todo el contenido del producto, incluyendo textos, guiones, plantillas
          y estrategias, está protegido por derechos de autor. Queda prohibida
          su reproducción, distribución o reventa sin autorización expresa por
          escrito.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-185">
          4. Descargo de responsabilidad
        </h3>
        <p data-id="element-186">
          Los resultados pueden variar según el esfuerzo, dedicación y
          circunstancias individuales de cada usuario. No garantizamos
          resultados específicos de ingresos o crecimiento de negocio. El
          producto ofrece herramientas y estrategias educativas, no asesoría
          financiera.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-187">
          5. Política de reembolso
        </h3>
        <p data-id="element-188">
          Debido a la naturaleza digital e inmediata del producto, no se ofrecen
          reembolsos una vez entregado el acceso. Te recomendamos revisar toda
          la información de esta página antes de realizar tu compra.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-189">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-190">
          En ningún caso seremos responsables por daños directos, indirectos,
          incidentales o consecuentes derivados del uso o la imposibilidad de
          uso del producto.
        </p>

        <h3 className="text-offwhite font-bold text-base" data-id="element-191">7. Modificaciones</h3>
        <p data-id="element-192">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor desde su publicación en
          esta página.
        </p>
      </LegalModal>
    </>;
}